import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from './core/services/authentication.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
	constructor(private readonly authService: AuthenticationService) {}

	ngOnInit(): void {
		this.authService.initializeAuthentication();
		this.authService.handleRedirect();
	}
}
